import React from 'react'

const Statement = () => {
  return (
    <div className="mace-statement">
      <h4>Statement of the problem</h4>
      <p>
        A website is owned by the company to facilitate its commercial purposes but it lacked a mobile application which can be easily accessible for majority of its target customers.
        The need for an e-commerce app that will serve as a marketplace for Rentacar’s vehicles was needed to boost patronage for the business, boost revenue, also to make bookings easier for customers.
      </p>
    </div>
  )
}

export default Statement